import { ArrowUpIcon } from "@phosphor-icons/react/dist/csr/ArrowUp";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "./IconButton";

const SHOW_AFTER = 320;

function appScrollContainer() {
  return document.querySelector<HTMLElement>("[data-app-scroll-container]");
}

/** Floating shortcut for returning to the top of the active app workspace. */
export function ScrollToTopButton() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const label = t("foundation.common.scrollToTop", {
    defaultValue: "Scroll to top",
  });

  useEffect(() => {
    const container = appScrollContainer();
    if (!container) return;

    const update = () => setVisible(container.scrollTop > SHOW_AFTER);
    update();
    container.addEventListener("scroll", update, { passive: true });
    return () => container.removeEventListener("scroll", update);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed bottom-[calc(1rem+env(safe-area-inset-bottom))] end-4 z-40">
      <IconButton
        type="button"
        tone="glass"
        tooltip={label}
        tooltipSide="top"
        tooltipAlign="end"
        aria-label={label}
        onClick={() => {
          const container = appScrollContainer();
          if (!container) return;
          const reduceMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)",
          ).matches;
          container.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
        }}
        className="studio-scroll-shortcut size-11"
      >
        <ArrowUpIcon aria-hidden="true" weight="bold" className="size-[18px]" />
      </IconButton>
    </div>
  );
}
